import * as React from "react";
import { useWindowDimensions } from "react-native";
import { createDrawerNavigator } from "@react-navigation/drawer";
import { drawerItemsMain } from "./ProductTrackerDrawerItemsMain ";
import CustomDrawerContent from "../../../components/custom/CustomDrawerContent";
import ItemTrackerScreen from "../../../screens/ItemTracker/ItemTrackerScreen";
import ItemTrackerDashboard from "../../../screens/ItemTracker/Dashboard/ItemTrackerDashboard";
import ProductTrackerDetailsReport from "../../../screens/ItemTracker/ProductTrackerDetailsReport";
import ChinaTrackerScreen from "../../../screens/ChinaTracker/ChinaTrackerScreen";
import { userClaimInformation } from "../../../models/usersModel";
import { useSelector } from "react-redux";
import teamsConfig from "../../../utils/constants/teams";
import roles from "../../../utils/constants/roles";
import { useTranslation } from "../../../utils/useTranslation";
import ChinaTrackerDetailsReport from "../../../screens/ChinaTracker/partials/ChinaTrackerDetailsReport";
import { View } from "../../../components/shared/Themed";
import Spinner from "../../../components/shared/Spinner";

const Drawer = createDrawerNavigator();

export default function ProductTrackerDrawerNavigator() {
  const [userProfile, setUserProfile] = React.useState<userClaimInformation>();
  const { userInfo, currentRole } = useSelector(
    (state: any) => state.configurations,
  );
  const { t } = useTranslation();
  const dimensions = useWindowDimensions();
  const { purchasing, sales, operation } = teamsConfig.teams;
  const { owner, admin } = roles.roles;
  const [isPurchasingTeam, setIsPurchasingTeam] = React.useState(false);
  const [filteredDrawerItems, setFilteredDrawerItems] =
    React.useState(drawerItemsMain);

  React.useEffect(() => {
    if (userInfo) {
      setUserProfile(userInfo);
    }
  }, [userInfo]);

  React.useEffect(() => {
    if (
      userProfile?.team?.toUpperCase() === purchasing ||
      currentRole?.includes(owner) ||
      currentRole?.includes(admin)
    ) {
      setIsPurchasingTeam(true);
    } else {
      setIsPurchasingTeam(false);
    }
  }, [userProfile, currentRole]);

  React.useEffect(() => {
    let updatedItems;
    updatedItems = drawerItemsMain.filter((item: any) => {
      if (item.key === "ChinaTracker") {
        return isPurchasingTeam;
      }
      return true;
    });
    setFilteredDrawerItems(updatedItems);
  }, [isPurchasingTeam]);

  if (!userProfile || !currentRole) {
    return (
      <View
        style={{
          flexDirection: "column",
          width: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spinner
          size="small"
          color="#74BBFF"
          styles={{
            flexDirection: "row",
            justifySelf: "center",
            alignSelf: "center",
          }}
        />
      </View>
    );
  }

  return (
    <Drawer.Navigator
      screenOptions={{
        drawerStyle: {
          width: 200,
        },
        drawerLabelStyle: {
          fontSize: 12,
          textTransform: "none",
        },
        drawerType: dimensions.width >= 768 ? "front" : "front",
      }}
      drawerContent={(props) => (
        <CustomDrawerContent drawerItems={filteredDrawerItems} {...props} />
      )}
    >
      <Drawer.Screen
        options={{
          drawerLabel: "ProductTracker",
          title: t("customerOrderTracker"),
        }}
        name="ProductTrackerReport"
        component={ItemTrackerScreen}
      />
      {isPurchasingTeam && (
        <Drawer.Screen
          options={{
            drawerLabel: "TrackerDashboard",
            title: t("trackerDashboard"),
          }}
          name="TrackerDashboardReport"
          component={ItemTrackerDashboard}
        />
      )}
      <Drawer.Screen
        options={{
          drawerLabel: "ProductTrackerDetailsReport",
          title: t("customerOrderTracker"),
        }}
        name="ProductTrackerDetailsReport"
        component={ProductTrackerDetailsReport}
      />

      <Drawer.Screen
        options={{
          drawerLabel: "ChinaTrackerDetailsReport",
          title: t("chinaOrderTracker"),
        }}
        name="ChinaTrackerDetailsReport"
        component={ChinaTrackerDetailsReport}
      />

      {isPurchasingTeam && (
        <Drawer.Screen
          options={{
            drawerLabel: "ChinaTracker",
            title: t("chinaOrderTracker"),
          }}
          name="ChinaTrackerReport"
          component={ChinaTrackerScreen}
        />
      )}
    </Drawer.Navigator>
  );
}
